export interface ProductCategoryInterface {
    id: number;
    code: string;
    label: string;
    children: ProductCategoryInterface[];
}

export const flattenProductCategoryLabels = (
    categories: ProductCategoryInterface[],
): string[] => {
    const labels: string[] = [];

    const walk = (nodes: ProductCategoryInterface[]): void => {
        for (const node of nodes) {
            labels.push(node.label);

            if (node.children.length > 0) {
                walk(node.children);
            }
        }
    };

    walk(categories);

    return labels;
};
